import React, { MouseEvent, ReactNode } from 'react';
import Link from '@/providers/Link';
import { urlPacotes } from '@/config/url';
import { NavElement, NavList, NavListItem } from './TravelTypeMenu.styles';
import { usePacotesListContext } from '@/features/pacote/PacotesList/context';
import { Title } from '@/components/typography';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import TravelTypeIcon from '@/features/pacote/PacotesList/components/TravelTypeIcon/TravelTypeIcon';

export interface TravelTypeMenuProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const TravelTypeMenu = ({ children, ...props }: TravelTypeMenuProps) => {
  const {
    data: { destino, travelTypes, queryTravelType },
  } = usePacotesListContext();
  const items: [PacoteTravelType] | null = travelTypes;
  if (!items) return null;

  return (
    <WhitePaper>
      <Title as="h3" textCase="uppercase" color="secondary_500" size="lg">
        Tipos de Viagem <span>para o destino {destino.title}</span>
      </Title>
      <NavElement>
        <NavList>
          <NavListItem active={!queryTravelType}>
            <Link href={urlPacotes(`${destino.slug}`)}>
              <TravelTypeIcon width={32} />
              Todos
            </Link>
          </NavListItem>
          {items.map(({ id, label, slug }) => (
            <NavListItem key={id} active={queryTravelType === id}>
              <Link href={urlPacotes(`${destino.slug}?travelType=${slug}`)}>
                <TravelTypeIcon id={id} width={32} />
                {label}
              </Link>
            </NavListItem>
          ))}
        </NavList>
      </NavElement>
    </WhitePaper>
  );
};

export default TravelTypeMenu;
